import { Text } from "./text";
import { deepmerge } from 'utilities/merge';
import autosize from 'autosize';
class InputsTextArea extends Text {
  defaultOpts = {
    rows: 3,
  }
  init(){
    this.opts = deepmerge(this.defaultOpts, this.opts)
    super.init();
    this.listenMount([this.onMountInputsTextArea])
  }
  public onChangeStore(a, b, c) {
    super.onChangeStore(a, b, c);
    autosize.update(this.querySelector('textarea'));
  }
  onMountInputsTextArea(){
    setTimeout(() => {
      autosize(this.querySelector('textarea'));
    }, 200)
  }
}

riot.mixin("inputs.textarea", InputsTextArea as riot.TagMixin)
